import moment from "moment";
import React from "react";

function formatDate(inputDate) {
  const date = new Date(inputDate);

  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
}

function CustomDateFormatter({ date }) {
  const localDate = moment.utc(date).local().toDate();

  return <span>{formatDate(localDate)}</span>;
}

export default CustomDateFormatter;
